import { FetchClubsDocument } from "src/generated-gql/graphql";
import { gql } from "graphql-tag";
import { Observable } from "rxjs";
import { OnInit } from "@angular/core";
import {
  DataService,
  ModalService,
  NotificationService,
  TypedBaseListComponent,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { Component } from "@angular/core";

@Component({
  selector: "fan-club-page",
  templateUrl: "./page.component.html",
  standalone: true,
  imports: [SharedModule],
})
export class FanClubPage
  extends TypedBaseListComponent<typeof FetchClubsDocument, "fanClubs">
  implements OnInit
{
  constructor(
    protected dataService: DataService,
    private modalService: ModalService,
    private notificationService: NotificationService
  ) {
    super();
    super.configure({
      document: FetchClubsDocument,
      getItems: (data) => {
        return data.fanClubs
      },
      setVariables: (skip, take) => ({
        options: {
          skip,
          take,
          filter: {
            name: {
              contains: this.searchTermControl.value,
            },
            ...this.filters.createFilterInput(),
          },
          sort: this.sorts.createSortInput(),
        },
      }),
      refreshListOnChanges: [
        this.sorts.valueChanges,
        this.filters.valueChanges,
      ],
    });
  }

  readonly filters = this.createFilterCollection()
    .addIdFilter()
    .addFilters([
      {
        name: "Artist Name",
        type: { kind: "text" },
        filterField: "artistName",
        label: "Artist Name",
      }
    ])
    .addDateFilters().connectToRoute(this.route);

  readonly sorts = this.createSortCollection()
    .defaultSort("createdAt", "DESC")
    .addSorts([
      { name: "id" },
      { name: "createdAt" },
      { name: "updatedAt" },
      { name: "name" },
      { name: "artistName" },
    ]);


  deleteFanClub(id:string) {
    this.dataService.mutate(
      gql`
        mutation RemoveFanClub($id: ID!) {
          deleteFanClub(id: $id) {
            result
          }
        }
      `,
      { id }
    ).subscribe(() => {
      this.notificationService.success("Fan Club Deleted");
      this.refresh();
    });
  } 
}